firebird.controller('meetingLoginCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$q',
    'cookieService',
    'logService',
    '$stateParams',
    '$location',
    'meetingAPIService',
    'socketService',
    'attendeeService',
    'hostsAPIService',
    'routerService',
    'meetingService',
    'helperService',
    'analyticsWrapperService',
    'vertoService',
    'presentationInvitationAPIService',
    'supportLinkService',
    'brandingService',
    'localizationService',
    'meetingStateService',
    'socketEventTransformerService',
    'authService',
    function (
        $window,
        $rootScope,
        $scope,
        $q,
        cookieService,
        logService,
        $stateParams,
        $location,
        meetingAPIService,
        socketService,
        attendeeService,
        hostsAPIService,
        routerService,
        meetingService,
        helperService,
        analyticsWrapperService,
        vertoService,
        presentationInvitationAPIService,
        supportLinkService,
        brandingService,
        localizationService,
        meetingStateService,
        socketEventTransformerService,
        authService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('meetingLoginCtrl');

        self.isHidden = isHidden;
        self.needPasswordValidation = true;
        self.meetingCode = meetingService.getMeetingCode();
        self.title = meetingService.getTitle();
        self.requiresPassword = meetingService.getRequiresPassword();
        self.isWebinar = meetingService.isWebinar();
        self.isHost = attendeeService.getIsHost();
        self.isCached = false;
        self.isMobile = helperService.isMobile();
        self.isUniteApplication = helperService.isUniteApplication();
        self.isLoginFormVisible = helperService.isLoginFormVisible();
        self.user = {};
        self.hasExistingCache = false;
        self.getExistingUserTooltip = getExistingUserTooltip;
        self.isPreferredBrowser = helperService.isChrome() || helperService.isElectron();
        self.isClientVersionSupported = isClientVersionSupported;
        self.isElectron = () => helperService.isElectron();
        self.isChrome = () => helperService.isChrome();
        self.getBrowserUpdateLink = getBrowserUpdateLink;
        self.inAppBrowserRef = null;

        self.init = init;
        self.login = login;
        self.submitLoginToServer = submitLoginToServer;
        self.sendTrustedUntrustedAnalytics = sendTrustedUntrustedAnalytics;
        self.loginSubmited = false;

        self.getTimedKey = getTimedKey;
        self.setTimedKey = setTimedKey;
        self.onHandleOpenURL = onHandleOpenURL;
        self.populateFields = populateFields;
        self.clearCacheAndFields = clearCacheAndFields;
        self.cacheUserData = cacheUserData;
        self.getFirstNameOfUser = getFirstNameOfUser;
        self.getClearCacheButtonWidth = getClearCacheButtonWidth;
        self.showForgotPassword = showForgotPassword;
        self.getLoginButtonText = getLoginButtonText;

        self.goBackToMobileLoginOrAccountView = goBackToMobileLoginOrAccountView;
        self.getLeftChevronLinkText = getLeftChevronLinkText;
        self.check = check;
        self.getPendoPlatformName = getPendoPlatformName;

        //App Update Status
        self.appUpdate = {};
        self.appUpdate.isAvailable = false;
        self.appUpdate.type = '';
        self.appUpdate.message = '';
        self.appUpdate.downloadURL = '';
        self.appUpdate.linkTitle = '';
        self.openInAppStore = openInAppStore;

        self.uniqueId = '';
        self.brandingLoginLogoUrl = '';
        self.getBrandingInfo = getBrandingInfo;
        self.getAppLogoURL = meetingService.getAppLogoURL;

        $window.document.addEventListener('handleopenurl', self.onHandleOpenURL);
        $window.document.addEventListener('sticky-handleopenurl', self.onHandleOpenURL);

        $scope.$on('$destroy', function () {
            if (helperService.isMobile()) {
                $window.document.removeEventListener('handleopenurl', self.onHandleOpenURL);
                helperService.refreshStickyEventListeners();
            }
        });

        self.init();

        ////////////////////////

        function isHidden() {
            return (
                (self.isHost && self.isClientVersionSupported()) ||
                self.isCached ||
                (self.requiresPassword && self.needPasswordValidation)
            );
        }

        function check() {
            if (self.user.meetingCode && self.user.meetingCode.toLowerCase() === 'iloveintermedia') {
                localStorage.setItem('enableMobileHostFeatures', true);
                $window.location.reload();
            } else {
                return true;
            }
        }

        function getBrandingInfo() {
            var meetingCodeWithoutDashes = self.meetingCode.replace(/-/g, '');

            if (meetingCodeWithoutDashes) {
                meetingAPIService.getBrandingInfo({ meetingCode: meetingCodeWithoutDashes }).then(
                    function (brandingInfo) {
                        if (brandingInfo && brandingInfo.logoURL) {
                            self.brandingLoginLogoUrl = brandingInfo.logoURL;
                        }
                    },
                    function (err) {
                        logger.error('#getBrandingInfo: Error retrieving branding info', err);
                    }
                );
            }
        }

        function init() {
            self.getBrandingInfo();
            self.isHost = attendeeService.getIsHost();

            var queryStrings = $location.search();
            if (queryStrings.destination && queryStrings.type) {
                routerService.setWebviewCaptureState(queryStrings);
                return;
            }

            self.uniqueId = helperService.getQueryParameter('rslt') || '';

            //Prepopulate fields from presentationInvitationResultId
            if (self.uniqueId) {
                var params = {
                    id: self.uniqueId
                };

                logger.log('init', 'Retrieving presentation invitation result by id:', self.uniqueId);

                presentationInvitationAPIService
                    .getPresentationInvitationResultById(params)
                    .then(function (rslt) {
                        logger.log('init', 'Received presentation invitation result:', rslt);

                        var isPresenter =
                            rslt.isPresenter === true ||
                            rslt.isPresenter === 'true' ||
                            rslt.isPresenter === 1 ||
                            rslt.isPresenter === '1';
                        var email = rslt.email || '';
                        var fullName = '';

                        if (rslt.firstName) {
                            fullName = rslt.firstName;

                            if (rslt.lastName) {
                                fullName += ' ' + rslt.lastName;
                            }
                        }

                        self.populateFields(fullName, email);
                    })
                    .catch(function (err) {
                        logger.error('init', 'Unable to retrieve presentation invitation result', err);
                    });
            }

            if (self.isHost) {
                if (!helperService.isMobile() && !self.isClientVersionSupported()) {
                    logger.log('init', 'Host detected on unsupported client version. Preventing autologin.');
                    return;
                }

                logger.log('init', 'Host detected.');

                var meetingAccessCode = meetingService.getMeetingCode();

                hostsAPIService.getHostDetails({ meetingAccessCode: meetingAccessCode }).then(
                    function (host) {
                        if ($stateParams && $stateParams.userAlreadyExists) {
                            analyticsWrapperService.eventTrack('meeting - host login email in use', {
                                category: 'login'
                            });

                            logger.log('init', 'Email already in use. No Autologin...');
                            self.populateFields(host.fullname);
                            self.needPasswordValidation = false;
                            self.isHost = false;
                            return;
                        }

                        logger.log('init', 'Autologin...');

                        //save user detail for host as well
                        //in the case that a logged in anymeetnig user
                        //joins other anymeeting meetingServerURI
                        //self.cacheUserData(host);

                        if (self.isMobile) {
                            host.meetingCode = helperService.getLocationHost() + '/' + self.meetingCode;
                        }
                        self.login(host);

                        meetingService.setHostNotificationCulture(host.notificationCulture);

                        meetingAPIService.getOnboardingInfo({ meetingCode: self.meetingCode }).then(
                            function (result) {
                                attendeeService.setOnboardingInfo(result);
                            },
                            function (err) {
                                logger.error('init', 'Unable to retrieve onboarding info', err);
                            }
                        );
                    },
                    function (err) {
                        logger.error('init', 'Unable to retrieve host details', err);
                    }
                );
            } else {
                var hashedPassword;
                var userCache = cookieService.getObject('userCache');

                if (userCache) {
                    self.hasExistingCache = true;
                }

                if (userCache && userCache.meetingCode === self.meetingCode) {
                    logger.log('init', 'User cache detected. ' + userCache);

                    if ($stateParams && $stateParams.userAlreadyExists) {
                        analyticsWrapperService.eventTrack('meeting - attendee login email in use', {
                            category: 'login'
                        });

                        logger.log('init', 'Email already in use. No Autologin...');
                        hashedPassword = userCache.user.hashedPassword || helperService.getQueryParameter('pwd');
                        self.populateFields(userCache.user.fullname, undefined, undefined, hashedPassword);
                        self.needPasswordValidation = false;
                        if (hashedPassword) {
                            self.requiresPassword = false;
                        }
                        return;
                    }

                    if (userCache.autologin) {
                        logger.log('init', 'Autologin...');
                        if (self.requiresPassword) {
                            self.populateFields(userCache.user.fullname, userCache.user.email);
                            hashedPassword = userCache.user.hashedPassword || helperService.getQueryParameter('pwd');

                            validateHashedPassword(hashedPassword).then(function (isPasswordValid) {
                                if (isPasswordValid) {
                                    userCache.user.hashedPassword = hashedPassword;
                                    self.isCached = true;
                                    self.login(userCache.user);
                                }
                            });
                        } else {
                            self.isCached = true;
                            self.login(userCache.user);
                        }
                    } else {
                        logger.log('init', 'No Autologin...');
                        self.populateFields(userCache.user.fullname, userCache.user.email);

                        if (self.requiresPassword) {
                            hashedPassword = userCache.user.hashedPassword || helperService.getQueryParameter('pwd');

                            validateHashedPassword(hashedPassword).then(function (isPasswordValid) {
                                if (isPasswordValid) {
                                    self.populateFields(undefined, undefined, undefined, hashedPassword);
                                }
                            });
                        }
                    }
                } else if (userCache && userCache.meetingCode !== self.meetingCode) {
                    //this is a new meeting, lets take whats in usercache's and populate user fields
                    //but do not autologin
                    self.populateFields(userCache.user.fullname, userCache.user.email);

                    if (self.requiresPassword) {
                        hashedPassword = helperService.getQueryParameter('pwd');
                        validateHashedPassword(hashedPassword).then(function (isPasswordValid) {
                            if (isPasswordValid) {
                                self.populateFields(
                                    userCache.user.fullname,
                                    userCache.user.email,
                                    undefined,
                                    hashedPassword
                                );
                            }
                        });
                    }
                } else {
                    //TODO: consolidate so that both mobile and desktop pull
                    //user data from same location (Cookies vs Local/Session Storage)
                    //
                    //TODO: angularize localStorage/sessionStorage (https://github.com/gsklee/ngStorage)
                    if (self.isMobile) {
                        // TODO: change to storageService
                        self.user.fullname = localStorage.getItem('fullname');
                        self.user.email = localStorage.getItem('email');
                        self.user.loginId = localStorage.getItem('loginId');
                        if (self.user.loginId) {
                            self.user.loginIdMeetingCode = localStorage.getItem('loginIdMeetingCode');
                        }

                        var autoReturnCode = self.getTimedKey('logged-in-meeting');
                        var autoPopulateCode = self.getTimedKey('prepop-meeting');

                        if ($stateParams && $stateParams.userAlreadyExists) {
                            analyticsWrapperService.eventTrack('meeting - mobile login email in use', {
                                category: 'login'
                            });

                            logger.log('init', 'Email already in use. No Autologin...');

                            self.user.email = '';

                            if (autoPopulateCode) {
                                self.user.meetingCode = autoPopulateCode;
                            }

                            return;
                        }

                        if (autoReturnCode) {
                            self.user.meetingCode = autoReturnCode;
                            self.login(self.user);
                        } else if (autoPopulateCode) {
                            self.user.meetingCode = autoPopulateCode;
                        } else if (helperService.getMobileHostLoggedIn()) {
                            self.user.meetingCode =
                                helperService.getLocationHost() + '/' + $stateParams.meetingAccessCode;
                            self.login(self.user);
                        }

                        //App Update Status
                        if ($stateParams && $stateParams.appUpdateStatus) {
                            self.appUpdate.isAvailable = $stateParams.appUpdateStatus.updateAvailable || false;
                            self.appUpdate.type = $stateParams.appUpdateStatus.type || '';
                            self.appUpdate.message = $stateParams.appUpdateStatus.message || '';
                            self.appUpdate.downloadURL = $stateParams.appUpdateStatus.downloadUrl || '';
                            self.appUpdate.linkTitle = $stateParams.appUpdateStatus.linkTitle || '';
                        }
                    } else {
                        if (self.requiresPassword) {
                            hashedPassword = helperService.getQueryParameter('pwd');

                            validateHashedPassword(hashedPassword).then(function (isPasswordValid) {
                                if (isPasswordValid) {
                                    self.populateFields(undefined, undefined, undefined, hashedPassword);
                                }
                            });
                        }
                    }
                }
            }
        }

        function validateHashedPassword(hashedPassword) {
            var deferred = $q.defer();

            if (hashedPassword) {
                meetingAPIService.validateHashedPassword(self.meetingCode, hashedPassword).then(
                    function (isPasswordValid) {
                        self.needPasswordValidation = false;
                        if (isPasswordValid) {
                            self.requiresPassword = false;
                        }
                        deferred.resolve(isPasswordValid);
                    },
                    function (err) {
                        self.needPasswordValidation = false;
                        deferred.resolve(false);
                        logger.error('validateHashedPassword', 'Error', err);
                        analyticsWrapperService.eventTrack('validation hashedPassword failure - ' + err, {
                            category: 'login'
                        });
                    }
                );
            } else {
                self.needPasswordValidation = false;
                deferred.resolve(false);
            }

            return deferred.promise;
        }

        function submitLoginToServer(user) {
            //Prevent multiple login clicks
            if (self.submittingLoginToServer) {
                return;
            }

            self.submittingLoginToServer = true;

            var postData = {
                name: user.fullname,
                location: user.location || '',
                email: user.email,
                attendantId: user.loginId,
                password: user.password,
                hashedPassword: user.hashedPassword,
                isHost: user.isHost || false,
                uniqueId: self.uniqueId
            };

            var params = {
                meetingCode: self.meetingCode
            };
            var userType = postData.isHost ? 'host' : 'attendee';

            self.loginSubmited = true;

            logger.log('login attempt (' + userType + ') for ' + user.email);
            analyticsWrapperService.eventTrack('meeting - ' + userType + ' login attempt', {
                category: 'login'
            });

            if (helperService.isVideoRoomApplication()) {
                logger.log('video room application found.  modifying login parameters');

                // TODO: Keep until final decision about implementation of task:
                // https://jira.imsecurityproducts.net/browse/ANYAM-76731
                postData.videoRoomAppType = 'display';
                var key = helperService.getQueryParameter('roomKey');
                if (key) {
                    logger.log('room key detected in query parameters: ' + key);
                    postData.videoRoomKey = key;
                } else {
                    logger.log('no room key detected in query parameters.');
                }
            }

            meetingAPIService
                .setNewAttendee(params, postData)
                .then(
                    function (attendee) {
                        //TODO: add handler logic in case attendee returns as null

                        analyticsWrapperService.eventTrack('meeting - ' + userType + ' login successful', {
                            category: 'login'
                        });

                        var attendeeObj = {
                            attendeeType: attendee.attendantType,
                            email: attendee.attendantEmail,
                            userIdentifier: attendee.userIdentifier,
                            attendantId: attendee.attendantID,
                            location: user.location || '',
                            screenName: attendee.attendantName,
                            attendantLoginId: attendee.attendantLoginID,
                            token: attendee.token,
                            hasWebRTC: helperService.browserHasWebRTC(),
                            isMobileAppUser: self.isMobile,
                            videoRoomAppUserId: attendee.videoRoomAppUserID,
                            isWebinar: self.isWebinar,
                            isTrusted: attendee.isTrusted,
                            isExternal: attendee.isExternal
                        };

                        attendeeService.init(attendeeObj);
                        analyticsWrapperService.setIsHost(self.isHost);

                        // Show Modal for presenter or co-presenter
                        if (!attendeeObj.hasWebRTC && self.isWebinar && attendeeService.getIsPresenter()) {
                            var emptyGUID = '00000000-0000-0000-0000-000000000000',
                                attendeeGUID = attendee.attendeeInvitationGuid;

                            if (attendeeGUID && attendeeGUID !== emptyGUID) {
                                return routerService.setChangeBrowserState(self.meetingCode, attendeeGUID);
                            }
                        }

                        if (analyticsWrapperService.getUsername() !== attendeeObj.email) {
                            analyticsWrapperService.resetUsername();
                        }

                        // Set Analytics identity if they are the logged in host
                        if (self.isHost) {
                            analyticsWrapperService.setUsername(attendeeObj.email);
                        }
                        analyticsWrapperService.setUserProperties({ Name: attendeeObj.screenName });
                        analyticsWrapperService.setUserProperties({ Email: attendeeObj.email });
                        analyticsWrapperService.updatePendoIdentity('client_platform', self.getPendoPlatformName());

                        if (self.isHost && user.extended) {
                            //should only happen for host
                            analyticsWrapperService.setUserProperties({
                                'Subscription Plan Name': user.extended.subscriptionPlanName
                            });
                            analyticsWrapperService.setUserProperties({
                                'Subscription Plan Price': user.extended.subscriptionPrice
                            });
                            analyticsWrapperService.updatePendoIdentity(
                                'subscription_plan_name',
                                user.extended.subscriptionPlanName
                            );
                            if (user.createdAtUnixTime) {
                                var temp = new Date(user.createdAtUnixTime * 1000);
                                analyticsWrapperService.setUserProperties({
                                    'AM Account Created Date': temp.toISOString()
                                });
                                analyticsWrapperService.updatePendoIdentity('user_created_date', temp.toISOString());
                            }
                        }

                        var reconnectTestingDelay = null;
                        if (helperService.getQueryParameter('reconnectionDelay')) {
                            reconnectTestingDelay = helperService.getQueryParameter('reconnectionDelay');
                            logger.log('Testing flag for reconnectionDelay found', reconnectTestingDelay);
                        }

                        self.sendTrustedUntrustedAnalytics(attendee);

                        //Connect to Socket
                        analyticsWrapperService.eventTrack('meeting - server socket - connection attempt');
                        socketService.connect(
                            meetingService.getMeetingServer(),
                            self.meetingCode,
                            reconnectTestingDelay
                        );

                        socketEventTransformerService.init();

                        user.password = undefined;
                        user.hashedPassword = attendee.hashedPassword;
                        user.loginId = attendeeObj.attendantId;
                        //Cache User Data
                        self.cacheUserData(user);

                        //Go to loading screen
                        routerService.setLoadingState();
                    },
                    function (err) {
                        logger.error('submitLoginToServer', 'Error in setNewAttendee', err);

                        analyticsWrapperService.eventTrack('meeting - ' + userType + ' login failure - ' + err, {
                            category: 'login'
                        });

                        if (err === 'already logged in' && helperService.isUniteApplication()) {
                            routerService.setUniteDuplicateLoginState();
                            return;
                        }

                        if (err === 'bad event password') {
                            self.isCached = false;
                            self.requiresPassword = true;
                            self.user.password = '';
                            return;
                        }

                        if (err === 'Meeting not active') {
                            routerService.setAlreadyEndedState();
                            return;
                        }

                        var title;
                        var msg;
                        var alreadyLoggedId = false;

                        switch (err) {
                            case 'bad email or password or not registered':
                                title = localizationService.translate('LOBBY_PAGE.DIALOG.LOGIN_FAILED');
                                msg = localizationService.translate(
                                    'LOBBY_PAGE.DIALOG.INVALID_EMAIL_AND_PASSWORD_COMBINATION'
                                );
                                break;
                            case 'already logged in':
                                alreadyLoggedId = true;
                                title = localizationService.translate('DIALOG.EMAIL_ALREADY_IN_USE');
                                msg = self.isHost
                                    ? localizationService.translate(
                                          'LOBBY_PAGE.DIALOG.PLEASE_MAKE_SURE_YOU_ARE_NOT_SIGNED_IN_ANOTHER_APP'
                                      )
                                    : localizationService.translate('DIALOG.PLEASE_USE_DIFFERENT_EMAIL');
                                break;
                            default:
                                title = localizationService.translate('LOBBY_PAGE.DIALOG.UH_OH');
                                msg = localizationService.translate('LOBBY_PAGE.DIALOG.ISSUE_LOGGING_IN_WITH_EMAIL');
                                break;
                        }

                        var confirmAction = function () {
                            window.swal.close();
                        };
                        var swalOptions;
                        if (self.isHost) {
                            //If host, give option to close the popup
                            if (helperService.getIsRedesign() === true) {
                                swalOptions = {
                                    title: title,
                                    text: '<div class="sweetalert-text-fix-size">' + msg + '</div>',
                                    showConfirmButton: true,
                                    showCancelButton: false,
                                    allowOutsideClick: true,
                                    confirmButtonColor: brandingService.getBaseColor(),
                                    confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT'),
                                    html: true,
                                    imageUrl: 'img/redesign/modal/pop-up-pic-error.svg',
                                    customClass: 'login-failure-host-modal auto-size'
                                };
                            } else {
                                //TODO: REMOVE POST-REDESIGN
                                swalOptions = {
                                    title: title,
                                    text: msg,
                                    type: 'error',
                                    showConfirmButton: true,
                                    showCancelButton: false,
                                    allowOutsideClick: true,
                                    confirmButtonColor: brandingService.getBaseColor(),
                                    confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT')
                                };
                            }
                        } else {
                            if (helperService.getIsRedesign() === true) {
                                var closeButtonHtml =
                                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                                swalOptions = {
                                    title: closeButtonHtml + title,
                                    text: msg,
                                    showConfirmButton: true,
                                    showCancelButton: true,
                                    allowOutsideClick: true,
                                    confirmButtonColor: brandingService.getBaseColor(),
                                    confirmButtonText: localizationService.translate(
                                        'LOBBY_PAGE.DIALOG.SIGN_IN_AS_A_HOST'
                                    ),
                                    cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                                    html: true,
                                    imageUrl: 'img/redesign/modal/pop-up-pic-error.svg',
                                    customClass: 'login-failure-host-modal'
                                };
                            } else {
                                //TODO: REMOVE POST-REDESIGN
                                swalOptions = {
                                    title: title,
                                    text: msg,
                                    type: 'error',
                                    showConfirmButton: true,
                                    allowOutsideClick: true,
                                    confirmButtonColor: brandingService.getBaseColor(),
                                    confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT')
                                };
                            }

                            //Clear email and password fields
                            self.user.email = '';
                            if (self.isWebinar || !alreadyLoggedId) {
                                self.user.password = '';
                            }
                        }

                        $window.swal(swalOptions, confirmAction);
                    }
                )
                .finally(function () {
                    self.submittingLoginToServer = false;
                });
        }

        function sendTrustedUntrustedAnalytics(attendee) {
            if (meetingService.isMeeting() && !self.isHost && !helperService.isVideoRoomApplication()) {
                if (attendee.isTrusted) {
                    analyticsWrapperService.eventTrack('AM - Trusted/Untrusted user - Trusted');
                } else {
                    const authToken = authService.getAuthToken();
                    analyticsWrapperService.eventTrack(
                        `AM - Trusted/Untrusted user - Untrusted ${authToken ? 'authorized' : 'unauthorized'}`
                    );
                }
            }
        }

        function getPendoPlatformName() {
            if (helperService.isUniteApplication()) {
                return 'Unite';
            }

            if (helperService.isUniteWeb()) {
                return 'Unite Web';
            }

            return 'Anymeeting Web';
        }

        function login(user) {
            if (self.isMobile) {
                logger.log('code --- ' + user.meetingCode);
                if (user.meetingCode === '') {
                    helperService.mobileAlert('Please enter a meeting code', 'Invalid Code');
                    return;
                }

                var code = user.meetingCode;

                //validate the code
                if (code.indexOf('/') > -1) {
                    var ary = code.split('/');
                    if (ary.length > 2) {
                        //TODO: need feedback to the user and have them try again
                        logger.error('login', 'meetingCode is invalid', code);
                        helperService.mobileAlert("We're sorry, that meeting code seems invalid.", 'Invalid Code');
                        return;
                    } else {
                        logger.log('setting mobile domain to: ' + ary[0] + ', code to: ' + ary[1]);
                        helperService.setMobileLocation(ary[0]);
                        code = ary[1];
                    }
                }

                analyticsWrapperService.initMobileAnalytics();

                var meetingIdentifier = code.replace(/-/g, '');

                helperService.setMobileMeetingIdentifier(meetingIdentifier);

                routerService.resolveInitialPath(meetingIdentifier).then(
                    function (meeting) {
                        logger.log('Meeting Object: ' + meeting);
                        meetingService.init(meeting);

                        self.meetingCode = meeting.meetingCode;

                        meetingStateService.meetingCode = meeting.meetingCode;
                        meetingStateService.meetingType = meeting.meetingTypeDisplay;
                        meetingStateService.nodeDomain = meeting.meetingServerURI;

                        analyticsWrapperService.storeMeetingCode(meeting.meetingCode);

                        if (meeting.requiresPassword === true) {
                            if (
                                user.loginId &&
                                user.loginIdMeetingCode &&
                                user.loginIdMeetingCode === meeting.meetingCode
                            ) {
                                self.submitLoginToServer(user);
                            } else {
                                helperService.mobilePrompt(
                                    'Enter the password that you registered with', // message
                                    function (results) {
                                        switch (results.buttonIndex) {
                                            case 1:
                                                // 'OK'
                                                if (results.input1 !== '') {
                                                    user.password = results.input1;
                                                    self.submitLoginToServer(user);
                                                } else {
                                                    helperService.mobileAlert(
                                                        'You did not enter a password', // message
                                                        'Invalid password', // title
                                                        function () {} // callback
                                                    );
                                                }
                                                break;
                                            case 2:
                                                // 'Cancel'
                                                break;
                                            case 3:
                                                // 'Forgot Password'
                                                // Go to WebConference/ForgotPassword page
                                                $window.cordova.InAppBrowser.open(
                                                    helperService.getForgotPasswordURL(meeting.meetingCode),
                                                    '_system'
                                                );
                                                break;
                                            default:
                                                // Dismissed without a button press (0)
                                                // or unhandled button
                                                break;
                                        }
                                    }, // callback to invoke
                                    'Webinar Password', // title
                                    ['OK', 'Cancel', 'Forgot Password'], // buttonLabels
                                    '' // defaultText
                                );
                            }
                        } else {
                            self.submitLoginToServer(user);
                        }
                    },
                    err => logger.error('login', 'Error in resolveInitialPath', err)
                );
            } else {
                if (self.user && self.user.email && self.user.email.length > 0) {
                    self.user.email = self.user.email.trim();
                }

                self.submitLoginToServer(user);
            }
        }

        function setTimedKey(key, val, msExpir) {
            if (!localStorage) {
                return;
            }
            var rec = { value: val, expiration: new Date().getTime() + msExpir };
            localStorage.setItem(key, JSON.stringify(rec));
        }

        function getTimedKey(key) {
            if (!localStorage) {
                return false;
            }

            var rec = localStorage.getItem(key);
            if (!rec) {
                return false;
            }

            rec = JSON.parse(rec);
            if (new Date().getTime() > rec.expiration) {
                localStorage.setItem(key, false);
                return false;
            }
            return rec.value;
        }

        function onHandleOpenURL(e) {
            var launchUrl = e && e.detail ? e.detail : '';

            if (launchUrl) {
                logger.log('Received mobile launch URL: ' + launchUrl);

                var recordingId = helperService.getRecordingId(launchUrl);
                if (recordingId && recordingId !== 'unknown') {
                    //Open recording URL with in-app browser
                    self.inAppBrowserRef = $window.cordova.InAppBrowser.open(launchUrl, '_blank', 'location=no');
                    $window.document.removeEventListener('sticky-handleopenurl', self.onHandleOpenURL);
                    return;
                } else if (self.inAppBrowserRef) {
                    self.inAppBrowserRef.close();
                    self.inAppBrowserRef = null;
                }

                var meetingIdentifier = helperService.getMeetingIdentifier(launchUrl);
                if (meetingIdentifier === 'unknown') {
                    //If Meeting Identifier does not exist,
                    //We don't need to do anything
                    return;
                }

                logger.log('Setting Mobile Meeting Identifier:', meetingIdentifier);
                helperService.setMobileMeetingIdentifier(meetingIdentifier);
                var fullMeetingIdentifier;
                var location = helperService.getHostNameFromUrl(launchUrl);
                var isProdURL = helperService.getEnvironment() === 'prod';

                //For Prod, we use just the Meeting Identifier
                //For Test Environments, we use full URL
                if (location && location !== 'unknown' && !isProdURL) {
                    location = location.replace('www.', '');
                    location = location.replace('meeting.', '');

                    fullMeetingIdentifier = location + '/' + meetingIdentifier;
                } else {
                    fullMeetingIdentifier = meetingIdentifier;
                }

                //IF statement is to prevent an unnecessary digest cycle...
                //No need to change it if its already there
                //
                //This populates the Meeting Code input field
                if (self.user.meetingCode !== fullMeetingIdentifier) {
                    self.user.meetingCode = fullMeetingIdentifier;
                    digest();
                }

                $window.document.removeEventListener('sticky-handleopenurl', self.onHandleOpenURL);
                helperService.refreshStickyEventListeners();
            }
        }

        function openInAppStore() {
            logger.log('Opening in app store... ' + self.appUpdate.downloadURL);
            $window.open(self.appUpdate.downloadURL, '_system');
        }

        function clearCacheAndFields() {
            self.user.fullname = '';
            self.user.email = '';
            cookieService.remove('userCache');
            self.hasExistingCache = false;
        }

        function populateFields(name, email, meetingCode, hashedPassword) {
            if (name) {
                self.user.fullname = name;
            }

            if (email) {
                self.user.email = email;
            }

            if (meetingCode) {
                self.user.meetingCode = meetingCode;
            }

            if (hashedPassword) {
                self.user.hashedPassword = hashedPassword;
            }
        }

        function getBrowserUpdateLink() {
            if (helperService.isChrome()) {
                return 'https://support.google.com/chrome/answer/95414';
            } else if (helperService.isFirefox()) {
                return 'https://support.mozilla.org/en-US/kb/update-firefox-latest-version';
            }

            return '';
        }

        function cacheUserData(user) {
            if (self.isMobile) {
                //Cache mobile user data
                localStorage.setItem('fullname', user.fullname);
                localStorage.setItem('email', user.email);
                localStorage.setItem('loginId', user.loginId);
                if (user.loginId) {
                    localStorage.setItem('loginIdMeetingCode', self.meetingCode);
                }

                var storedMeeting = self.meetingCode;
                if (helperService.getLocationHost().indexOf('anymeeting.com') == -1) {
                    storedMeeting = helperService.getLocationHost() + '/' + self.meetingCode;
                }

                self.setTimedKey('logged-in-meeting', storedMeeting, 5 * 60 * 1000);
                self.setTimedKey('prepop-meeting', storedMeeting, 30 * 60 * 1000);
            } else {
                //Cache non-mobile user data

                var userCache = {
                    meetingCode: self.meetingCode,
                    user: user,
                    autologin: self.isHost ? false : true
                };

                var inAYear = new Date();
                inAYear.setDate(inAYear.getYear() + 1);
                cookieService.putObject('userCache', userCache, { expires: inAYear, secure: true, samesite: 'strict' });
            }
        }

        function showForgotPassword() {
            meetingService.openExternalLink(helperService.getForgotPasswordURL(meetingService.getMeetingCode()));
        }

        function getLoginButtonText() {
            return self.isWebinar
                ? localizationService.translate('LOBBY_PAGE.DIALOG.JOIN_THE_WEBINAR')
                : localizationService.translate('LOBBY_PAGE.JOIN_BUTTON');
        }

        function getExistingUserTooltip() {
            var userCache = cookieService.getObject('userCache');
            if (userCache) {
                return localizationService.translate('LOBBY_PAGE.DIALOG.WE_RECOGNIZED_YOU_FROM_PREVIOUS_MEETING');
            }
            return '';
        }

        function getFirstNameOfUser(user) {
            if (user && user.fullname) {
                return user.fullname.split(' ')[0];
            }
            return localizationService.translate('COMMON.YOU_TEXT').toLowerCase();
        }

        function getClearCacheButtonWidth() {
            return angular.element('#clear-cache-btn').outerWidth() + 15;
        }

        function goBackToMobileLoginOrAccountView() {
            if (helperService.getMobileHostLoggedIn()) {
                routerService.setMobileHostAccountView();
            } else {
                routerService.setMobileHostLoginView();
            }
        }

        function getLeftChevronLinkText() {
            return helperService.getMobileHostLoggedIn() ? 'Account' : 'Sign in';
        }

        function isClientVersionSupported() {
            if (helperService.isElectron()) {
                return helperService.isElectronVersionSupported();
            } else {
                return helperService.isBrowserVersionSupported();
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
